import React, { useState, useContext, useEffect } from 'react';
import { capitalizeString } from '../../utils/utils';
import { getCasosEnCurso } from '../../api/salusService';
import { Modal } from 'app-principal-componentes-visuales';
import PageWrapper from '../../components/PageWrapper/PageWrapper';
import { DETALLE_CASO, HISTORIAL_ATENCIONES } from '../../utils/constants';
import CasosEnCurso from '../../components/Atenciones/CasosEnCurso/CasosEnCurso';
import { AsistenciaMedicaContext } from '../../contexts/AsistenciaMedicaContext';
import { cargarHistorialFinalizado } from '../../helpers/historialFinalizadoHelper';
import HistorialSkeleton from '../../components/Skeletons/HistorialSkeleton/HistorialSkeleton';
import { filtrarCasosEnCurso, filtrarCasosEnHistorial } from '../../helpers/serviciosEnCursoHelper';
import HistorialFinalizadas from '../../components/Atenciones/HistorialFinalizadas/HistorialFinalizadas';
import { AsistenciaMedicaActionType } from '../../interfaces/global-state/asistencia.medica.action.type.enum';
import FiltroHistorialAtenciones from '../../components/Modals/FiltroHistorialAtenciones/FiltroHistorialAtenciones';
import './HistorialAtenciones.scss'

const HistorialAtenciones = ({ history }) => {

    const { asistenciaMedica, useRequest, dispatchAsistenciaMedica, storageManager, isWeb } = useContext(AsistenciaMedicaContext);
    const { apiRequest } = useRequest();
    const { asistenciasFinalizadas } = asistenciaMedica;
    const { serviciosEnCurso, isServicioEnCurso } = history.location.state;
    const socio = asistenciaMedica.usuario;
    const isPrincipal = socio.contratos !== undefined;
    const [showGrupoFamiliarModal, setShowGrupoFamiliarModal] = useState(false);
    const [grupoFamiliar, setGrupoFamiliar] = useState([]);
    const [placeholder, setPlaceholder] = useState('Todo el grupo familiar');
    const [placeholderFinalizadas, setPlaceholderFinalizadas] = useState(capitalizeString(socio.nombre + ' ' + socio.apellidos));
    const [serviciosEnCursoFilter, setServiciosEnCursoFilter] = useState(serviciosEnCurso);
    const [serviciosFinalizados, setServiciosFinalizados] = useState(asistenciasFinalizadas);
    const [seleccionados, setSeleccionados] = useState([]);
    const [historialSkeleton, setHistorialSkeleton] = useState(true);
    const [icFinalizados, setIcFinalizados] = useState(socio.ic);
    const [casoFinalizadoPorFecha, setCasoFinalizadoPorFecha] = useState([]);
    const [casoFinalizadosOrdenados, setCasoFinalizadosOrdenados] = useState([]);
    const [errorFinalizadas, setErrorFinalizadas] = useState(false);
    const tipoDeAsistencia = isServicioEnCurso ? 'en-curso' : 'finalizadas';

    useEffect(() => {
        const grupoFamiliarAux = socio.familiares.length > 0 ? [...socio.familiares] : []
        grupoFamiliarAux.unshift(socio)
        setGrupoFamiliar(grupoFamiliarAux)
        setSeleccionados(grupoFamiliarAux);
        cargarHistorial();
    }, []);

    const openSelectGrupoFamiliarModal = () => setShowGrupoFamiliarModal(true);

    const handleDetalleCaso = (servicioEnCurso) => {
       history.push(DETALLE_CASO, {
            casoEnCursoSeleccionado: servicioEnCurso,
            from: HISTORIAL_ATENCIONES
        });
    }

    /**
    * Obtiene la lista de casos basado en el numero de contrato guardado en cada caso.
    */
    const cargarHistorial = async () => {
        setHistorialSkeleton(true);
        isServicioEnCurso ? casosEnCurso() : historialAtencionesFinalizadas(socio.ic);
    }

    const casosEnCurso = async () => {
        try {
            const casos = await getCasosEnCurso(socio.ic, apiRequest);
            if(casos?.status === 200) {
                storageManager.setDataStorage("casosEnCurso", JSON.stringify(casos?.data));
                const casosHistorial = await filtrarCasosEnHistorial(casos?.data, asistenciaMedica.clasificaciones, asistenciaMedica.servicios, asistenciaMedica.canales);
                casosHistorial.sort((a, b) => new Date(b.fechaCreacion).getTime() - new Date(a.fechaCreacion).getTime())
                const casosFiltrados = await filtrarCasosEnCurso(casosHistorial);
                //TODO ¿es necesario filtrar con el metodo de filtrarAtenciones encargado de filtrar los servicios diferentes a GT?
                setServiciosEnCursoFilter(casosFiltrados);
                dispatchAsistenciaMedica({
                    type: AsistenciaMedicaActionType.actualizarCasosEnCurso,
                    casosEnCurso: casosFiltrados
                });
            } else {
                setServiciosEnCursoFilter(serviciosEnCurso);
            }
        } catch(error) {
            console.error(`ASIS-MED - Hubo un problema asociado al llamado de servicios en curso ${error}`);
        } finally {
            setHistorialSkeleton(false);
        }
    }

    /**
     * Encargado de obtener las atenciones finalizadas, y guardarlas en el contexto
     */
    const historialAtencionesFinalizadas = async (ic) => {
        try {
            let socioFinalizadas;
            if (ic === socio.ic) {
                socioFinalizadas = socio;
            } else {
                let auxiliar = grupoFamiliar.filter(familiar => {
                    if (ic === familiar.ic) {
                        return familiar;
                    }
                })
                socioFinalizadas = auxiliar[0];
            }
            const casosHistorialFinalizados = await cargarHistorialFinalizado(ic, apiRequest, socioFinalizadas, asistenciaMedica.clasificaciones, asistenciaMedica.servicios, asistenciaMedica.canales);
            casosHistorialFinalizados.sort((a, b) => new Date(b.fechaCreacion).getTime() - new Date(a.fechaCreacion).getTime())
            setServiciosFinalizados(casosHistorialFinalizados);
            setIcFinalizados(ic);
            if(ic === socio.ic) {
                dispatchAsistenciaMedica({
                    type: AsistenciaMedicaActionType.actualizarAtencionesFinalizadas,
                    casosFinalizados: casosHistorialFinalizados
                });
            }
            filtrarAtencionesPorFecha(casosHistorialFinalizados);
        } catch (error: any) {
            console.error(`ASIS-MED - Hubo un problema asociado al llamado del servicio de Salus ${error}`);
            setErrorFinalizadas(true);
        } finally {
            setHistorialSkeleton(false);
        }
    }

    /**
     * Encargado de separar las fecha de las atenciones finalizadas por año 
     * @param casosSinDuplicados
     */
    const filtrarAtencionesPorFecha = (casosSinDuplicados) => {
        let casosFinalizadosPorFecha = [];

        casosFinalizadosPorFecha = casosSinDuplicados.reduce((resultado, caso) => {
            const fechaCreacion = new Date(caso.fechaCreacion);
            const year = fechaCreacion.getFullYear().toString();

            if (!resultado[year]) {
                resultado[year] = [];
            }
            resultado[year].push(caso);
            return resultado;
        }, {});

        const finalizadosOrdenados = Object.keys(casosFinalizadosPorFecha).sort((a, b) => {
            const fechaA = new Date(casosFinalizadosPorFecha[a][0].fechaCreacion).getTime();
            const fechaB = new Date(casosFinalizadosPorFecha[b][0].fechaCreacion).getTime();
            return fechaB - fechaA;
        });

        setCasoFinalizadosOrdenados(finalizadosOrdenados)
        setCasoFinalizadoPorFecha(casosFinalizadosPorFecha);
    }

    const handleHistorial = (socioSeleccionado) => {
        setHistorialSkeleton(true);
        historialAtencionesFinalizadas(socioSeleccionado);
    }

    return (
        <>
            { historialSkeleton ?
                <PageWrapper
                    pageClassName='asistencia-medica asistencia-historial-atenciones'
                    tituloHeader={isServicioEnCurso ? 'Asistencia en curso' : 'Asistencias finalizadas'}
                    socio={asistenciaMedica.usuario}
                    className={isWeb && 'h-100'}
                    path={HISTORIAL_ATENCIONES}
                    notCancel
                >
                    <HistorialSkeleton />
                </PageWrapper>
            :
                <>
                    <PageWrapper
                        pageClassName='asistencia-medica asistencia-historial-atenciones'
                        tituloHeader={isServicioEnCurso ? 'Asistencia en curso' : 'Asistencias finalizadas'}
                        socio={asistenciaMedica.usuario}
                        className={isWeb && 'h-100'}
                        path={HISTORIAL_ATENCIONES}
                        notCancel
                    >
                        { tipoDeAsistencia === 'en-curso' ? (
                            <CasosEnCurso
                                socio={socio}
                                servicios={serviciosEnCursoFilter}
                                placeholder={placeholder}
                                isPrincipal={isPrincipal}
                                seleccionados={seleccionados}
                                handleDetalleCaso={handleDetalleCaso}
                                openSelectGrupoFamiliarModal={openSelectGrupoFamiliarModal}
                            /> )
                        : (
                            <HistorialFinalizadas
                                socio={socio}
                                isPrincipal={isPrincipal}
                                placeholder={placeholderFinalizadas}
                                serviciosFinalizados={serviciosFinalizados}
                                casoFinalizadoPorFecha={casoFinalizadoPorFecha}
                                casoFinalizadosOrdenados={casoFinalizadosOrdenados}
                                errorFinalizadas={errorFinalizadas}
                                openSelectGrupoFamiliarModal={openSelectGrupoFamiliarModal}
                                handleDetalleCaso={handleDetalleCaso}
                            />
                        )}
                    </PageWrapper>
                    <Modal
                        className='modal_web-large'
                        hideCloseBtn={false}
                        setShowModal={setShowGrupoFamiliarModal}
                        showModal={showGrupoFamiliarModal}
                        id="historial-grupo-familiar-modal"
                        //@ts-ignore
                        component={
                            <FiltroHistorialAtenciones
                                tabSeleccionado={tipoDeAsistencia}
                                seleccionados={seleccionados}
                                setSeleccionados={setSeleccionados}
                                setShowGrupoFamiliarModal={setShowGrupoFamiliarModal}
                                setPlaceholder={setPlaceholder}
                                setPlaceholderFinalizadas={setPlaceholderFinalizadas}
                                grupoFamiliar={grupoFamiliar}
                                setServiciosEnCursoFilter={setServiciosEnCursoFilter}
                                serviciosEnCurso={serviciosEnCurso}
                                handleHistorial={handleHistorial}
                                icFinalizados={icFinalizados}
                            />
                        }
                    />
                </>
            }
        </>
    )
}

export default HistorialAtenciones;